var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tags-show"},[_vm._l((_vm.list),function(item){return [_c('div',{key:item.cate_id,staticClass:"tags-row"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(item.name))]),_vm._l((item.child),function(cItem){return [_c('a-tag',{key:cItem.label,style:({
            color: _vm.darken(item.color),
            borderColor: _vm.darken(item.color),
          }),attrs:{"color":cItem.color}},[_vm._v(_vm._s(cItem.name))])]})],2)]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }